import { Theme } from '@material-ui/core/styles'
import dateRangeStyle from '../DateRangePicker/style'

/**
 * Reuse date range colors and calendar styling in a compact single-calendar modal.
 */
const style = (theme: Theme): ReturnType<typeof dateRangeStyle> => {
    const shared = dateRangeStyle(theme)
    return {
        ...shared,
        paper: { ...shared.paper, width: 440 }
    }
}

export default style
